// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderStripsPopup-module__font-s-10___oUHLa {
  font-size: 10px !important;
}

.OrderStripsPopup-module__font-s-12___tQnwN {
  font-size: 12px !important;
}

.OrderStripsPopup-module__font-s-13____DLTO {
  font-size: 13px !important;
}

.OrderStripsPopup-module__font-s-14___e_7HB {
  font-size: 14px !important;
}

.OrderStripsPopup-module__font-s-15___Ybwa2 {
  font-size: 15px !important;
}

.OrderStripsPopup-module__font-s-16___Bn1kl {
  font-size: 16px !important;
}

.OrderStripsPopup-module__font-s-18___H59hb {
  font-size: 18px !important;
}

.OrderStripsPopup-module__font-s-20___QO_W9 {
  font-size: 20px !important;
}

.OrderStripsPopup-module__font-s-22___SEUq6 {
  font-size: 22px !important;
}

.OrderStripsPopup-module__font-s-28___lxpec {
  font-size: 28px !important;
}

.OrderStripsPopup-module__font-w-400___Dwyjf {
  font-weight: 400 !important;
}

.OrderStripsPopup-module__font-w-500___JdEbN {
  font-weight: 500 !important;
}

.OrderStripsPopup-module__font-w-600___luegx {
  font-weight: 600 !important;
}

.OrderStripsPopup-module__font-w-700___ykQm8 {
  font-weight: 700 !important;
}

.OrderStripsPopup-module__p-5___kCaE9 {
  padding: 5px !important;
}

.OrderStripsPopup-module__p-12___jJUDG {
  padding: 12px !important;
}

.OrderStripsPopup-module__p-16___w6hyy {
  padding: 16px !important;
}

.OrderStripsPopup-module__p-30___xDU0I {
  padding: 30px !important;
}

.OrderStripsPopup-module__p-b-0___e_ZWU {
  padding-bottom: 0 !important;
}

.OrderStripsPopup-module__p-b-5___PknhL {
  padding-bottom: 5px !important;
}

.OrderStripsPopup-module__p-b-10___sE6Yz {
  padding-bottom: 10px !important;
}

.OrderStripsPopup-module__p-b-12___pCNdG {
  padding-bottom: 12px !important;
}

.OrderStripsPopup-module__p-b-16___B3tYl {
  padding-bottom: 16px !important;
}

.OrderStripsPopup-module__p-b-18___Hj_Vy {
  padding-bottom: 18px !important;
}

.OrderStripsPopup-module__p-b-20___dHzv0 {
  padding-bottom: 20px !important;
}

.OrderStripsPopup-module__p-b-25___PI5bk {
  padding-bottom: 25px !important;
}

.OrderStripsPopup-module__p-b-30___h6S2k {
  padding-bottom: 30px !important;
}

.OrderStripsPopup-module__p-b-50___lVL0T {
  padding-bottom: 50px !important;
}

.OrderStripsPopup-module__p-t-0___aKySr {
  padding-top: 0 !important;
}

.OrderStripsPopup-module__p-t-12___FZItF {
  padding-top: 12px !important;
}

.OrderStripsPopup-module__p-t-16___TQH5e {
  padding-top: 16px !important;
}

.OrderStripsPopup-module__p-t-18___gHjWK {
  padding-top: 18px !important;
}

.OrderStripsPopup-module__p-t-20___n48dE {
  padding-top: 20px !important;
}

.OrderStripsPopup-module__p-t-30___X1Pyt {
  padding-top: 30px !important;
}

.OrderStripsPopup-module__p-t-40___Rd_wA {
  padding-top: 40px !important;
}

.OrderStripsPopup-module__p-t-50___gs76O {
  padding-top: 50px !important;
}

.OrderStripsPopup-module__p-l-20___BxC9Y {
  padding-left: 20px !important;
}

.OrderStripsPopup-module__p-l-30___eGm1K {
  padding-left: 30px !important;
}

.OrderStripsPopup-module__p-l-40___ZX_LH {
  padding-left: 40px !important;
}

.OrderStripsPopup-module__p-r-16___F31mz {
  padding-right: 16px !important;
}

.OrderStripsPopup-module__p-r-20___ez_Qu {
  padding-right: 20px !important;
}

.OrderStripsPopup-module__p-r-30___ngUSr {
  padding-right: 30px !important;
}

.OrderStripsPopup-module__p-r-50___l66dU {
  padding-right: 50px !important;
}

.OrderStripsPopup-module__p-r-60___p3VcQ {
  padding-right: 60px !important;
}

.OrderStripsPopup-module__m-b-1___u_JKx {
  margin-bottom: 1px !important;
}

.OrderStripsPopup-module__m-b-2___tN0T3 {
  margin-bottom: 2px !important;
}

.OrderStripsPopup-module__m-b-6___RXX5h {
  margin-bottom: 6px !important;
}

.OrderStripsPopup-module__m-b-8___A2vy1 {
  margin-bottom: 8px !important;
}

.OrderStripsPopup-module__m-b-10___bI9BF {
  margin-bottom: 10px !important;
}

.OrderStripsPopup-module__m-b-14___Dm_bO {
  margin-bottom: 14px !important;
}

.OrderStripsPopup-module__m-b-16___HzOBy {
  margin-bottom: 16px !important;
}

.OrderStripsPopup-module__m-b-20___rYdWQ {
  margin-bottom: 20px !important;
}

.OrderStripsPopup-module__m-b-22___pT5bu {
  margin-bottom: 22px !important;
}

.OrderStripsPopup-module__m-b-24___Wk_FR {
  margin-bottom: 24px !important;
}

.OrderStripsPopup-module__m-b-30___MRtyG {
  margin-bottom: 30px !important;
}

.OrderStripsPopup-module__m-b-32___rUbip {
  margin-bottom: 32px !important;
}

.OrderStripsPopup-module__m-b-40___HpUbo {
  margin-bottom: 40px !important;
}

.OrderStripsPopup-module__m-t-2___PSjiS {
  margin-top: 2px !important;
}

.OrderStripsPopup-module__m-t-3___fYNmB {
  margin-top: 3px !important;
}

.OrderStripsPopup-module__m-t-4___c2yVZ {
  margin-top: 4px !important;
}

.OrderStripsPopup-module__m-t-5___BYaiI {
  margin-top: 5px !important;
}

.OrderStripsPopup-module__m-t-8___qQrdN {
  margin-top: 8px !important;
}

.OrderStripsPopup-module__m-t-10___RlA5D {
  margin-top: 10px !important;
}

.OrderStripsPopup-module__m-t-15___VbloY {
  margin-top: 15px !important;
}

.OrderStripsPopup-module__m-t-16___KGjGJ {
  margin-top: 16px !important;
}

.OrderStripsPopup-module__m-t-20___NzVo6 {
  margin-top: 20px !important;
}

.OrderStripsPopup-module__m-t-22___CMNyX {
  margin-top: 22px !important;
}

.OrderStripsPopup-module__m-t-30___EH7uA {
  margin-top: 30px !important;
}

.OrderStripsPopup-module__m-t-32___E4y98 {
  margin-top: 32px !important;
}

.OrderStripsPopup-module__m-l-auto___Rkyui {
  margin-left: auto !important;
}

.OrderStripsPopup-module__m-l-4___VsECE {
  margin-left: 4px !important;
}

.OrderStripsPopup-module__m-l-5___LgQp7 {
  margin-left: 5px !important;
}

.OrderStripsPopup-module__m-l-6___d_RFv {
  margin-left: 6px !important;
}

.OrderStripsPopup-module__m-l-8___uH23u {
  margin-left: 8px !important;
}

.OrderStripsPopup-module__m-l-10___QxziA {
  margin-left: 10px !important;
}

.OrderStripsPopup-module__m-l-16___ITEOH {
  margin-left: 16px !important;
}

.OrderStripsPopup-module__m-l-20___oLFiB {
  margin-left: 20px !important;
}

.OrderStripsPopup-module__m-l-24___Pp1HW {
  margin-left: 24px !important;
}

.OrderStripsPopup-module__m-l-30___FZy9X {
  margin-left: 30px !important;
}

.OrderStripsPopup-module__m-l-35___gWfMF {
  margin-left: 35px !important;
}

.OrderStripsPopup-module__m-l-40___sP_ns {
  margin-left: 40px !important;
}

.OrderStripsPopup-module__m-r-8___TzRHZ {
  margin-right: 8px !important;
}

.OrderStripsPopup-module__m-r-10___hnHHy {
  margin-right: 10px !important;
}

.OrderStripsPopup-module__m-r-16___e1rd_ {
  margin-right: 16px !important;
}

.OrderStripsPopup-module__m-r-20___EIBuR {
  margin-right: 20px !important;
}

.OrderStripsPopup-module__m-r-24___bL7QQ {
  margin-right: 24px !important;
}

.OrderStripsPopup-module__m-r-30___dIwog {
  margin-right: 30px !important;
}

.OrderStripsPopup-module__m-r-40___NVl2J {
  margin-right: 40px !important;
}

.OrderStripsPopup-module__border-r-3___d3A7y {
  border-radius: 3px !important;
}

.OrderStripsPopup-module__border-r-4___EK7GW {
  border-radius: 4px !important;
}

.OrderStripsPopup-module__border-r-6___eDDkg {
  border-radius: 6px !important;
}

.OrderStripsPopup-module__border-r-10___dQkds {
  border-radius: 10px !important;
}

.OrderStripsPopup-module__border-r-12___DEFgm {
  border-radius: 12px !important;
}

.OrderStripsPopup-module__border-r-16___eHCkW {
  border-radius: 16px !important;
}

.OrderStripsPopup-module__border-r-50___K_QFU {
  border-radius: 50% !important;
}

.OrderStripsPopup-module__primary-border___MxA9z {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderStripsPopup-module__primary-border-b___FLrGu {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderStripsPopup-module__primary-border-t___fJJTg {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderStripsPopup-module__primary-border-l___mM3cZ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderStripsPopup-module__primary-border-r___LsE5L {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderStripsPopup-module__secondary-border___opybk {
  border: 1px solid #637768;
}

.OrderStripsPopup-module__secondary-border-b___S336g {
  border-bottom: 1px solid #637768;
}

.OrderStripsPopup-module__secondary-border-t___UTUW7 {
  border-top: 1px solid #637768;
}

.OrderStripsPopup-module__secondary-border-l___FIMzA {
  border-left: 1px solid #637768;
}

.OrderStripsPopup-module__secondary-border-r___VjrWz {
  border-right: 1px solid #637768;
}

.OrderStripsPopup-module__gap-0___Lqzed {
  gap: 0 !important;
}

.OrderStripsPopup-module__gap-2____ljdU {
  gap: 2px !important;
}

.OrderStripsPopup-module__gap-4___ZBHX5 {
  gap: 4px !important;
}

.OrderStripsPopup-module__gap-5___VQ1lE {
  gap: 5px !important;
}

.OrderStripsPopup-module__gap-6___TZ0ke {
  gap: 6px !important;
}

.OrderStripsPopup-module__gap-8___U9JN0 {
  gap: 8px !important;
}

.OrderStripsPopup-module__gap-10___vd6q6 {
  gap: 10px !important;
}

.OrderStripsPopup-module__gap-12___V717D {
  gap: 12px !important;
}

.OrderStripsPopup-module__gap-14___mFd5F {
  gap: 14px !important;
}

.OrderStripsPopup-module__gap-16___XZxmF {
  gap: 16px !important;
}

.OrderStripsPopup-module__gap-18___i1PY0 {
  gap: 18px !important;
}

.OrderStripsPopup-module__gap-20___Vt7Yi {
  gap: 20px !important;
}

.OrderStripsPopup-module__gap-24___MTZub {
  gap: 24px !important;
}

.OrderStripsPopup-module__gap-26___ysFFr {
  gap: 26px !important;
}

.OrderStripsPopup-module__gap-30___I3WAM {
  gap: 30px !important;
}

.OrderStripsPopup-module__gap-32___vdHjj {
  gap: 32px !important;
}

.OrderStripsPopup-module__gap-40___ugzpU {
  gap: 40px !important;
}

.OrderStripsPopup-module__gap-50___cgF_C {
  gap: 50px !important;
}

.OrderStripsPopup-module__flex-1___rYB0e {
  flex: 1;
}

.OrderStripsPopup-module__flex-none___wpYn8 {
  flex: none !important;
}

.OrderStripsPopup-module__flex-column___Z9wK4 {
  display: flex;
  flex-direction: column !important;
}

.OrderStripsPopup-module__flex-row___EX_jG {
  display: flex;
  flex-direction: row !important;
}

.OrderStripsPopup-module__vertically-centered____Jukp {
  display: flex;
  align-items: center !important;
}

.OrderStripsPopup-module__horizontally-centered___pfnvA {
  display: flex;
  justify-content: center !important;
}

.OrderStripsPopup-module__horizontally-end___jL6Qo {
  display: flex;
  justify-content: end !important;
}

.OrderStripsPopup-module__vertically-start___K53vr {
  display: flex;
  align-items: start !important;
}

.OrderStripsPopup-module__space-between___UFZlh {
  display: flex;
  justify-content: space-between !important;
}

.OrderStripsPopup-module__flex-wrap___vpiV1 {
  flex-wrap: wrap !important;
}

.OrderStripsPopup-module__height-100___K2Mkg {
  height: 100%;
}

.OrderStripsPopup-module__width-50___m7GE0 {
  width: 50% !important;
}

.OrderStripsPopup-module__width-100___qL6_R {
  width: 100%;
}

.OrderStripsPopup-module__cursor-pointer___J_j4H {
  cursor: pointer;
}

.OrderStripsPopup-module__cursor-not-allowed____sIYo {
  cursor: not-allowed !important;
}

.OrderStripsPopup-module__absolute-centered___M0hNQ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.OrderStripsPopup-module__absolute___gB1Am {
  position: absolute;
}

.OrderStripsPopup-module__relative___LSqpQ {
  position: relative;
}

.OrderStripsPopup-module__fixed___nWE2p {
  position: fixed;
}

.OrderStripsPopup-module__visible___ml1ID {
  opacity: 1;
}

.OrderStripsPopup-module__invisible___duZfQ {
  opacity: 0;
}

.OrderStripsPopup-module__col-90___ZMMHb {
  width: 90% !important;
}

.OrderStripsPopup-module__col-auto___ihsJE {
  width: auto !important;
}

.OrderStripsPopup-module__medical-tabs___u6Qgt {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.OrderStripsPopup-module__medical-table-new___RlXma {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderStripsPopup-module__medical-table-new___RlXma:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderStripsPopup-module__medical-table-new___RlXma::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderStripsPopup-module__medical-table-new___RlXma::-webkit-scrollbar-track {
  display: none;
}
.OrderStripsPopup-module__medical-table-new___RlXma.OrderStripsPopup-module__no-pagination___lUkgk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderStripsPopup-module__medical-table-new___RlXma.OrderStripsPopup-module__no-pagination___lUkgk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderStripsPopup-module__medical-table-new___RlXma.OrderStripsPopup-module__no-pagination___lUkgk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderStripsPopup-module__medical-table-new___RlXma.OrderStripsPopup-module__no-pagination___lUkgk::-webkit-scrollbar-track {
  display: none;
}

.OrderStripsPopup-module__medical-table-empty___IsneD {
  padding: 14px 40px !important;
}

.OrderStripsPopup-module__icon-btn___C3_7y {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.OrderStripsPopup-module__search-icon___cGFPO {
  width: 24px;
  height: 24px;
  align-self: center;
}

.OrderStripsPopup-module__disable-select___P7yp8 {
  user-select: none;
}

.OrderStripsPopup-module__break-word____oKXp {
  word-break: break-word;
}

.OrderStripsPopup-module__popup-clear-btn___vit05 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.OrderStripsPopup-module__scroll-m-b-20___oFSod {
  scroll-margin-bottom: 20px;
}

.OrderStripsPopup-module__tabs___EaMb_ {
  padding: 0;
  margin: 20px 30px 18px 30px;
  gap: 30px;
}

.OrderStripsPopup-module__buttonsContainer___ETSzU {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 19px 30px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}
.OrderStripsPopup-module__buttonsContainer___ETSzU .OrderStripsPopup-module__button____tgl4 {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/OrderStripsPopup/OrderStripsPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,UAAA;EACA,2BAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,2CAAA;AA8pBF;AA5pBE;EACE,aAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.tabs {\n  padding: 0;\n  margin: 20px 30px 18px 30px;\n  gap: 30px;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding: 19px 30px;\n  gap: 16px;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n\n  .button {\n    display: flex;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `OrderStripsPopup-module__font-s-10___oUHLa`,
	"fontS12": `OrderStripsPopup-module__font-s-12___tQnwN`,
	"fontS13": `OrderStripsPopup-module__font-s-13____DLTO`,
	"fontS14": `OrderStripsPopup-module__font-s-14___e_7HB`,
	"fontS15": `OrderStripsPopup-module__font-s-15___Ybwa2`,
	"fontS16": `OrderStripsPopup-module__font-s-16___Bn1kl`,
	"fontS18": `OrderStripsPopup-module__font-s-18___H59hb`,
	"fontS20": `OrderStripsPopup-module__font-s-20___QO_W9`,
	"fontS22": `OrderStripsPopup-module__font-s-22___SEUq6`,
	"fontS28": `OrderStripsPopup-module__font-s-28___lxpec`,
	"fontW400": `OrderStripsPopup-module__font-w-400___Dwyjf`,
	"fontW500": `OrderStripsPopup-module__font-w-500___JdEbN`,
	"fontW600": `OrderStripsPopup-module__font-w-600___luegx`,
	"fontW700": `OrderStripsPopup-module__font-w-700___ykQm8`,
	"p5": `OrderStripsPopup-module__p-5___kCaE9`,
	"p12": `OrderStripsPopup-module__p-12___jJUDG`,
	"p16": `OrderStripsPopup-module__p-16___w6hyy`,
	"p30": `OrderStripsPopup-module__p-30___xDU0I`,
	"pB0": `OrderStripsPopup-module__p-b-0___e_ZWU`,
	"pB5": `OrderStripsPopup-module__p-b-5___PknhL`,
	"pB10": `OrderStripsPopup-module__p-b-10___sE6Yz`,
	"pB12": `OrderStripsPopup-module__p-b-12___pCNdG`,
	"pB16": `OrderStripsPopup-module__p-b-16___B3tYl`,
	"pB18": `OrderStripsPopup-module__p-b-18___Hj_Vy`,
	"pB20": `OrderStripsPopup-module__p-b-20___dHzv0`,
	"pB25": `OrderStripsPopup-module__p-b-25___PI5bk`,
	"pB30": `OrderStripsPopup-module__p-b-30___h6S2k`,
	"pB50": `OrderStripsPopup-module__p-b-50___lVL0T`,
	"pT0": `OrderStripsPopup-module__p-t-0___aKySr`,
	"pT12": `OrderStripsPopup-module__p-t-12___FZItF`,
	"pT16": `OrderStripsPopup-module__p-t-16___TQH5e`,
	"pT18": `OrderStripsPopup-module__p-t-18___gHjWK`,
	"pT20": `OrderStripsPopup-module__p-t-20___n48dE`,
	"pT30": `OrderStripsPopup-module__p-t-30___X1Pyt`,
	"pT40": `OrderStripsPopup-module__p-t-40___Rd_wA`,
	"pT50": `OrderStripsPopup-module__p-t-50___gs76O`,
	"pL20": `OrderStripsPopup-module__p-l-20___BxC9Y`,
	"pL30": `OrderStripsPopup-module__p-l-30___eGm1K`,
	"pL40": `OrderStripsPopup-module__p-l-40___ZX_LH`,
	"pR16": `OrderStripsPopup-module__p-r-16___F31mz`,
	"pR20": `OrderStripsPopup-module__p-r-20___ez_Qu`,
	"pR30": `OrderStripsPopup-module__p-r-30___ngUSr`,
	"pR50": `OrderStripsPopup-module__p-r-50___l66dU`,
	"pR60": `OrderStripsPopup-module__p-r-60___p3VcQ`,
	"mB1": `OrderStripsPopup-module__m-b-1___u_JKx`,
	"mB2": `OrderStripsPopup-module__m-b-2___tN0T3`,
	"mB6": `OrderStripsPopup-module__m-b-6___RXX5h`,
	"mB8": `OrderStripsPopup-module__m-b-8___A2vy1`,
	"mB10": `OrderStripsPopup-module__m-b-10___bI9BF`,
	"mB14": `OrderStripsPopup-module__m-b-14___Dm_bO`,
	"mB16": `OrderStripsPopup-module__m-b-16___HzOBy`,
	"mB20": `OrderStripsPopup-module__m-b-20___rYdWQ`,
	"mB22": `OrderStripsPopup-module__m-b-22___pT5bu`,
	"mB24": `OrderStripsPopup-module__m-b-24___Wk_FR`,
	"mB30": `OrderStripsPopup-module__m-b-30___MRtyG`,
	"mB32": `OrderStripsPopup-module__m-b-32___rUbip`,
	"mB40": `OrderStripsPopup-module__m-b-40___HpUbo`,
	"mT2": `OrderStripsPopup-module__m-t-2___PSjiS`,
	"mT3": `OrderStripsPopup-module__m-t-3___fYNmB`,
	"mT4": `OrderStripsPopup-module__m-t-4___c2yVZ`,
	"mT5": `OrderStripsPopup-module__m-t-5___BYaiI`,
	"mT8": `OrderStripsPopup-module__m-t-8___qQrdN`,
	"mT10": `OrderStripsPopup-module__m-t-10___RlA5D`,
	"mT15": `OrderStripsPopup-module__m-t-15___VbloY`,
	"mT16": `OrderStripsPopup-module__m-t-16___KGjGJ`,
	"mT20": `OrderStripsPopup-module__m-t-20___NzVo6`,
	"mT22": `OrderStripsPopup-module__m-t-22___CMNyX`,
	"mT30": `OrderStripsPopup-module__m-t-30___EH7uA`,
	"mT32": `OrderStripsPopup-module__m-t-32___E4y98`,
	"mLAuto": `OrderStripsPopup-module__m-l-auto___Rkyui`,
	"mL4": `OrderStripsPopup-module__m-l-4___VsECE`,
	"mL5": `OrderStripsPopup-module__m-l-5___LgQp7`,
	"mL6": `OrderStripsPopup-module__m-l-6___d_RFv`,
	"mL8": `OrderStripsPopup-module__m-l-8___uH23u`,
	"mL10": `OrderStripsPopup-module__m-l-10___QxziA`,
	"mL16": `OrderStripsPopup-module__m-l-16___ITEOH`,
	"mL20": `OrderStripsPopup-module__m-l-20___oLFiB`,
	"mL24": `OrderStripsPopup-module__m-l-24___Pp1HW`,
	"mL30": `OrderStripsPopup-module__m-l-30___FZy9X`,
	"mL35": `OrderStripsPopup-module__m-l-35___gWfMF`,
	"mL40": `OrderStripsPopup-module__m-l-40___sP_ns`,
	"mR8": `OrderStripsPopup-module__m-r-8___TzRHZ`,
	"mR10": `OrderStripsPopup-module__m-r-10___hnHHy`,
	"mR16": `OrderStripsPopup-module__m-r-16___e1rd_`,
	"mR20": `OrderStripsPopup-module__m-r-20___EIBuR`,
	"mR24": `OrderStripsPopup-module__m-r-24___bL7QQ`,
	"mR30": `OrderStripsPopup-module__m-r-30___dIwog`,
	"mR40": `OrderStripsPopup-module__m-r-40___NVl2J`,
	"borderR3": `OrderStripsPopup-module__border-r-3___d3A7y`,
	"borderR4": `OrderStripsPopup-module__border-r-4___EK7GW`,
	"borderR6": `OrderStripsPopup-module__border-r-6___eDDkg`,
	"borderR10": `OrderStripsPopup-module__border-r-10___dQkds`,
	"borderR12": `OrderStripsPopup-module__border-r-12___DEFgm`,
	"borderR16": `OrderStripsPopup-module__border-r-16___eHCkW`,
	"borderR50": `OrderStripsPopup-module__border-r-50___K_QFU`,
	"primaryBorder": `OrderStripsPopup-module__primary-border___MxA9z`,
	"primaryBorderB": `OrderStripsPopup-module__primary-border-b___FLrGu`,
	"primaryBorderT": `OrderStripsPopup-module__primary-border-t___fJJTg`,
	"primaryBorderL": `OrderStripsPopup-module__primary-border-l___mM3cZ`,
	"primaryBorderR": `OrderStripsPopup-module__primary-border-r___LsE5L`,
	"secondaryBorder": `OrderStripsPopup-module__secondary-border___opybk`,
	"secondaryBorderB": `OrderStripsPopup-module__secondary-border-b___S336g`,
	"secondaryBorderT": `OrderStripsPopup-module__secondary-border-t___UTUW7`,
	"secondaryBorderL": `OrderStripsPopup-module__secondary-border-l___FIMzA`,
	"secondaryBorderR": `OrderStripsPopup-module__secondary-border-r___VjrWz`,
	"gap0": `OrderStripsPopup-module__gap-0___Lqzed`,
	"gap2": `OrderStripsPopup-module__gap-2____ljdU`,
	"gap4": `OrderStripsPopup-module__gap-4___ZBHX5`,
	"gap5": `OrderStripsPopup-module__gap-5___VQ1lE`,
	"gap6": `OrderStripsPopup-module__gap-6___TZ0ke`,
	"gap8": `OrderStripsPopup-module__gap-8___U9JN0`,
	"gap10": `OrderStripsPopup-module__gap-10___vd6q6`,
	"gap12": `OrderStripsPopup-module__gap-12___V717D`,
	"gap14": `OrderStripsPopup-module__gap-14___mFd5F`,
	"gap16": `OrderStripsPopup-module__gap-16___XZxmF`,
	"gap18": `OrderStripsPopup-module__gap-18___i1PY0`,
	"gap20": `OrderStripsPopup-module__gap-20___Vt7Yi`,
	"gap24": `OrderStripsPopup-module__gap-24___MTZub`,
	"gap26": `OrderStripsPopup-module__gap-26___ysFFr`,
	"gap30": `OrderStripsPopup-module__gap-30___I3WAM`,
	"gap32": `OrderStripsPopup-module__gap-32___vdHjj`,
	"gap40": `OrderStripsPopup-module__gap-40___ugzpU`,
	"gap50": `OrderStripsPopup-module__gap-50___cgF_C`,
	"flex1": `OrderStripsPopup-module__flex-1___rYB0e`,
	"flexNone": `OrderStripsPopup-module__flex-none___wpYn8`,
	"flexColumn": `OrderStripsPopup-module__flex-column___Z9wK4`,
	"flexRow": `OrderStripsPopup-module__flex-row___EX_jG`,
	"verticallyCentered": `OrderStripsPopup-module__vertically-centered____Jukp`,
	"horizontallyCentered": `OrderStripsPopup-module__horizontally-centered___pfnvA`,
	"horizontallyEnd": `OrderStripsPopup-module__horizontally-end___jL6Qo`,
	"verticallyStart": `OrderStripsPopup-module__vertically-start___K53vr`,
	"spaceBetween": `OrderStripsPopup-module__space-between___UFZlh`,
	"flexWrap": `OrderStripsPopup-module__flex-wrap___vpiV1`,
	"height100": `OrderStripsPopup-module__height-100___K2Mkg`,
	"width50": `OrderStripsPopup-module__width-50___m7GE0`,
	"width100": `OrderStripsPopup-module__width-100___qL6_R`,
	"cursorPointer": `OrderStripsPopup-module__cursor-pointer___J_j4H`,
	"cursorNotAllowed": `OrderStripsPopup-module__cursor-not-allowed____sIYo`,
	"absoluteCentered": `OrderStripsPopup-module__absolute-centered___M0hNQ`,
	"absolute": `OrderStripsPopup-module__absolute___gB1Am`,
	"relative": `OrderStripsPopup-module__relative___LSqpQ`,
	"fixed": `OrderStripsPopup-module__fixed___nWE2p`,
	"visible": `OrderStripsPopup-module__visible___ml1ID`,
	"invisible": `OrderStripsPopup-module__invisible___duZfQ`,
	"col90": `OrderStripsPopup-module__col-90___ZMMHb`,
	"colAuto": `OrderStripsPopup-module__col-auto___ihsJE`,
	"medicalTabs": `OrderStripsPopup-module__medical-tabs___u6Qgt`,
	"medicalTableNew": `OrderStripsPopup-module__medical-table-new___RlXma`,
	"noPagination": `OrderStripsPopup-module__no-pagination___lUkgk`,
	"medicalTableEmpty": `OrderStripsPopup-module__medical-table-empty___IsneD`,
	"iconBtn": `OrderStripsPopup-module__icon-btn___C3_7y`,
	"searchIcon": `OrderStripsPopup-module__search-icon___cGFPO`,
	"disableSelect": `OrderStripsPopup-module__disable-select___P7yp8`,
	"breakWord": `OrderStripsPopup-module__break-word____oKXp`,
	"popupClearBtn": `OrderStripsPopup-module__popup-clear-btn___vit05`,
	"scrollMB20": `OrderStripsPopup-module__scroll-m-b-20___oFSod`,
	"tabs": `OrderStripsPopup-module__tabs___EaMb_`,
	"buttonsContainer": `OrderStripsPopup-module__buttonsContainer___ETSzU`,
	"button": `OrderStripsPopup-module__button____tgl4`
};
module.exports = ___CSS_LOADER_EXPORT___;
